import { defineStore } from 'pinia'

import { actions } from './actions'
import { createInitialState } from './state'
import { getters } from './getters'

export const useCheckoutStore = defineStore('checkout', {
  state: createInitialState,
  actions,
  getters,
})
